import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    base_api: window.location.hostname == 'localhost' ? 'http://localhost/Inteqc/api/' : `https://${window.location.hostname}`+'/api/',
    base_url : window.location.hostname == 'localhost' ? 'http://localhost:8080/InteqcAdmin/' : `https://${window.location.hostname}`+'/',
    base_url_route : window.location.hostname == 'localhost' ? '' : '',
    base_url_front : window.location.hostname == 'localhost' ? 'http://localhost/Inteqc/' : `https://${window.location.hostname}`+'/',
    authen : {},
    header_bearer : {'Authorization': `Bearer ${localStorage.getItem('tokenAccess')}`},
    req : Axios.create({
        baseURL: '/',
        timeout: 0,
        headers: {'Authorization': `Bearer ${localStorage.getItem('tokenAccess')}`}
    }),
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    locale:'th',
    overlay:false,
  },
  mutations: {
    set_auth(state,value){
            state.authen = value;
    },
    set_locale(state,value){
            state.locale = value;
    },
    set_overlay(state,value){
            state.overlay = value;
    },
  },
  actions: {

  },

  getters: {
    req: state => state.req,
    base_api : state => state.base_api,
    base_url : state => state.base_url,
    base_url_route : state => state.base_url_route,
    base_url_front : state => state.base_url_front,
    authen : state => state.authen,
    header : state => state.header_bearer,
    locale : state => state.locale,
    overlay : state => state.overlay,
  }
})
